import firebase from 'firebase';

const productionConfig = {
    apiKey: "AIzaSyAX8JoQPr5Icq8Ug5InnjVr9F14R31Q8zE",
    authDomain: "living-ledger-web.firebaseapp.com",
    databaseURL: "https://living-ledger-web.firebaseio.com",
    projectId: "living-ledger-web",
    storageBucket: "living-ledger-web.appspot.com",
    messagingSenderId: "986703409449",
    appId: "1:986703409449:web:404650a7d8f4d3364f4738"
};

const developmentConfig = {
    apiKey: "AIzaSyCC43Pusx2GjF99_zn513Vb3WrB63wEdUc",
    authDomain: "living-ledger-dev.firebaseapp.com",
    databaseURL: "https://living-ledger-dev.firebaseio.com",
    projectId: "living-ledger-dev",
    storageBucket: "living-ledger-dev.appspot.com",
    messagingSenderId: "1009838579064",
    appId: "1:1009838579064:web:f6dc6261f92472c91efc8d"
};

class Firebase {
    constructor() {
        this.env = this.__getEnv();
        this.config = this.__getConfig();
        firebase.initializeApp(this.config);

        this.auth = firebase.auth();
        this.database = firebase.firestore();
        this.functions = firebase.functions();

        if (process.env.NODE_ENV !== 'production') {
            this.functions.useFunctionsEmulator('http://localhost:5001');
            this.database.settings({ host: 'localhost:8080',  ssl: false });
            // this.auth.useEmulator('http://localhost:9099');
        }

        this.servers = {
            localhost: 'http://localhost:5001',
            development: `https://${developmentConfig.projectId}.firebaseapp.com`,
            production: `https://${productionConfig.projectId}.firebaseapp.com`,
        };
    }

    __getConfig() {
        return this.env === 'production' ? productionConfig : developmentConfig;
    }

    __getEnv() {
        if (window.location.hostname === 'localhost') {
            return 'localhost'
        } else if (process.env.NODE_ENV === 'development') {
            return 'development';
        } else {
            return 'production';
        }
    }

    signOut() {
        return this.auth.signOut();
    }

    async fetch(route, params) {
        if (!this.auth.currentUser) throw new Error("User is not logged in");
        const token = await this.auth.currentUser.getIdToken();

        if (params.body) params.body = JSON.stringify(params.body);
        const url = `${this.servers[this.env]}/${this.config.projectId}/us-central1/api${route}`;

        const response = await fetch(url, {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${token}`,
            },
            ...params,
        });
        const data = await response.json();
        return data;
    }
}

export default new Firebase();